export default __webpack_public_path__ + "static/media/bktransfer.0c899262.png";